module.exports = __webpack_public_path__ + "static/media/DM.9b38e11e.png";